import React from 'react';
import cn from 'classnames';
import './ParentARMBox.scss';
import ParentScoreItemStatusBlock from './ParentScoreItemStatusBlock';
import ParentPeopleLevels from './ParentPeopleLevels';
import { isNullOrUndefined } from '../../../../../services/util';
import arrowImage from '../../../../../../assets/reports/parent/arrow.png';
import { useSelector } from 'react-redux';
import { getPercentileInfo, isUsingFourCategories } from '../../../util/cutscores';

// box above progress chart with ARM score information for a window
const ParentARMBox = ({ armBox, isLatestARMBox, armBoxRefs, i18n }) => {
  const selectedStatePercentileCuts = useSelector(state => state.reports.teacher.selectedStatePercentileCuts);
  const isUsingFourCutlines = isUsingFourCategories(selectedStatePercentileCuts);
  
  if (!armBox) return null;
  
  const { score, label, metric, percentile, color, pacing } = armBox;

  let percentileInfo = null;
  if (isUsingFourCutlines) percentileInfo = getPercentileInfo(percentile, selectedStatePercentileCuts);

  const getScore = () => {
    if(!score && metric === 'ORF') return 'N/A';
    if(!score && metric === 'ARM') return 'N/A';

    const displayedScore = score;

    return (
      <>
        <div className="score-value">
          {displayedScore}
          {isLatestARMBox && metric === 'ARM' &&
            <>
              <img src={arrowImage} className="score-arrow arrow-left" />
              <img src={arrowImage} className="score-arrow arrow-right" />
            </>
          }
        </div>
        <div className="score-label">{label}</div>
      </>
    );
  }

  const className = cn({
    'parent-ARM-box': true,
    'hidden': isNullOrUndefined(score),
  })

  return (
    <div id={armBox.assessment?.activityId} className={className} ref={el => armBoxRefs.current[armBox.window] = el}>
      <div className="__value parent-score-summary-score">{getScore()}</div>
      <div className="__value parent-score-summary-percentile">
        <ParentPeopleLevels pacing={pacing} percentage={percentile} i18n={i18n} percentileInfo={percentileInfo} />
      </div>
      <div className="__value parent-score-summary-status">
        <ParentScoreItemStatusBlock color={color} pacing={pacing} i18n={i18n} percentileInfo={percentileInfo} />
      </div>
    </div>
  )

}

export default ParentARMBox;